import { __decorate } from "tslib";
import { __metadata } from "tslib";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DateValidationService } from '../../../services/data-service';
var DateDropdownComponent = /*@__PURE__*/ (function () {
    function DateDropdownComponent(_serviceDateValidation) {
        this._serviceDateValidation = _serviceDateValidation;
        this.hasError = false;
        this.dateChange = new EventEmitter();
        this.years = [];
        this.days = this.oneToN(31);
        this._serviceDateValidation = _serviceDateValidation;
    }
    DateDropdownComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var then;
            return __generator(this, function (_a) {
                this.months = this._serviceDateValidation.getMonths();
                this.today = new Date();
                // without timestamp
                this.today = new Date(this.today.toDateString());
                then = new Date();
                if (this.minDaysInFuture) {
                    then.setDate(this.today.getDate() + this.minDaysInFuture);
                }
                else if (this.minWorkDaysInFuture) {
                    this._serviceDateValidation.addWorkDays({ startDate: then, days: this.minWorkDaysInFuture });
                }
                this.day = then.getDate();
                this.month = then.getMonth() + 1;
                this.year = then.getFullYear();
                // set years to select (today plus n years)
                this.years = this.startPlusN({ start: this.today.getFullYear(), n: 5 });
                this.dateChanged();
                return [2 /*return*/];
            });
        });
    };
    DateDropdownComponent.prototype.monthChanged = function () {
        var daysInMonth = this.daysInMonth(this.month, this.year);
        this.days = this.oneToN(daysInMonth);
        this.day = this.days.length >= this.day ? this.days[this.day] : this.days[0];
        this.dateChanged();
    };
    DateDropdownComponent.prototype.daysInMonth = function (month, year) {
        return new Date(year, month, 0).getDate();
    };
    DateDropdownComponent.prototype.oneToN = function (n) {
        return (Array(n) + '').split(',').map(function (d, i) {
            return i + 1;
        });
    };
    DateDropdownComponent.prototype.startPlusN = function (_a) {
        var start = _a.start, n = _a.n;
        var diff = n;
        if (diff > -1) {
            return (Array(diff) + '').split(',').map(function (d, i) {
                return i + start;
            });
        }
        else {
            return [];
        }
    };
    DateDropdownComponent.prototype.validate = function () {
        var hasError = false;
        var input = new Date(this.year, this.month - 1, this.day);
        if (this.maxDaysInPast) {
            hasError =
                hasError ||
                    this._serviceDateValidation.valMaxDaysInPast({
                        today: this.today,
                        date: input,
                        maxDaysInPast: this.maxDaysInPast
                    });
        }
        if (this.minDaysInFuture) {
            hasError =
                hasError ||
                    this._serviceDateValidation.valMinDaysInFuture({
                        date: input,
                        today: this.today,
                        minDaysInFuture: this.minDaysInFuture
                    });
        }
        if (this.minWorkDaysInFuture) {
            hasError =
                hasError ||
                    this._serviceDateValidation.valMinWorkDaysInFuture({
                        date: input,
                        today: this.today,
                        minWorkDaysInFuture: this.minWorkDaysInFuture
                    });
        }
        if (this.maxDaysInFuture) {
            hasError =
                hasError ||
                    this._serviceDateValidation.valMaxDaysInFuture({
                        date: input,
                        today: this.today,
                        maxDaysInFuture: this.maxDaysInFuture
                    });
        }
        if (this.needsToBeWorkDay) {
            hasError =
                hasError ||
                    this._serviceDateValidation.isBankHoliday(input) ||
                    this._serviceDateValidation.isWeekend(input);
        }
        return hasError;
    };
    DateDropdownComponent.prototype.dateChanged = function () {
        this.hasError = this.validate();
        if (!this.hasError) {
            this.dateChange.emit(this.day + '.' + this.month + '.' + this.year);
        }
        else {
            this.dateChange.emit('');
        }
    };
    return DateDropdownComponent;
}());
export { DateDropdownComponent };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/shared/components/date-dropdown/date-dropdown.component.ts
// module id = null
// module chunks = 